import type { CooldownData } from '../businessLogicService/brainBreakCooldown';

export const BRAIN_BREAK_FLAG_NAME = 'LTS-shutoff-TEAME-218-Brain-Break';
export const COOLDOWN_VARIANT_NAME = 'last_completed';
export const BRAIN_BREAK_TIMING = {
  EMOTION_HIGHLIGHT_MS: 650,
  STEP_TRANSITION_MS: 300,
  COMPLETION_DURATION_S: 2.5,
} as const;

export const BRAIN_BREAK_EVENTS = {
  COMPLETION_EXIT_STARTED: 'brainbreak:completion_exit_started',
  COMPLETION_FINISHED: 'brainbreak:completion_finished',
  COMPLETE: 'brainBreakComplete',
} as const;

export type BrainBreakAnimationPhase = 'enter' | 'idle' | 'exit';

// Placement types
export type BrainBreakPlacement =
  | 'post-login'
  | 'about-the-skill'
  | 'worked-example'
  | 'practice-problems'
  | 'assessment-completed'
  | 'assessment-completed_passed'
  | 'assessment-completed_failed';

export interface BrainBreakState {
  hasSeenBrainBreak: boolean;
  isEligible: boolean;
  isModalOpen: boolean;
  isHydrated: boolean;
  assignedPlacement: BrainBreakPlacement | null;
  currentPlacement: BrainBreakPlacement | null;
  navigationCallback: (() => void) | null;
  cooldownData: CooldownData | undefined;
  animationPhase: BrainBreakAnimationPhase;
}

export interface BrainBreakActions {
  showBrainBreak: (navigationCallback?: () => void, onComplete?: () => void, placement?: BrainBreakPlacement) => void;
  markAsViewed: () => void;
  closeWithAnimation: () => void;
}
